import React, { useEffect } from "react";

export default function InfoModal({
  open,
  type = "info", // "info" | "success" | "error" | "warning"
  title = "Bilgi",
  message = "",
  onClose,
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const colorMap = {
    info: "bg-blue-100 text-blue-800",
    success: "bg-green-100 text-green-800",
    error: "bg-red-100 text-red-800",
    warning: "bg-amber-100 text-amber-800",
  };

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative bg-white w-full max-w-md rounded-2xl shadow-xl p-6">
        <div
          className={`inline-block px-3 py-1 rounded-full text-sm font-semibold mb-4 ${colorMap[type]}`}
        >
          {title}
        </div>
        <p className="text-gray-700 mb-6">{message}</p>
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="px-5 py-2 rounded-full bg-[#07183c] text-white hover:bg-[#0a204f]"
          >
            Tamam
          </button>
        </div>
      </div>
    </div>
  );
}
